<div [ngSwitch]="columnType">
  <div *ngSwitchCase="STATUS" nzTooltipTitle="{{columnValue | removeUnderscore | uppercase }}"
    nzTooltipPlacement="bottom" nz-tooltip [nzTooltipColor]="'white'" nzTooltipOverlayClassName="custom-tooltip-col"
    [nzTooltipTrigger]="columnValue?.length > 15 ? 'hover':null" class="status-col">
    <span [class]="'tag-'+ columnValue?.toLowerCase()">
      {{columnValue |removeUnderscore|uppercase}}
    </span>
  </div>
  <div *ngSwitchCase="TRANS_TYPE" nzTooltipTitle="{{columnValue | removeUnderscore | uppercase }}"
    nzTooltipPlacement="bottom" nz-tooltip [nzTooltipColor]="'white'" nzTooltipOverlayClassName="custom-tooltip-col"
    [nzTooltipTrigger]="columnValue?.length > 15 ? 'hover':null">
    <span [class]="'trans-type-default trans-type-'+ convertToRefineName(columnValue)">
      {{convertToRefineName(columnValue)|removeUnderscore|uppercase|truncate:15}}</span>
  </div>
  <div *ngSwitchCase="AMOUNT">
    {{columnValue === null ? '' : 'moniepoint.currency_symbol'|translate}} {{columnValue === null ? '---' :
    columnValue|majorAmount|currency}}
  </div>
  <div *ngSwitchCase="REF" [title]="columnValue">
    {{columnValue|truncate:15}}
  </div>
  <div *ngSwitchCase="TERMINAL_TYPE">
    <span
      [class]="'terminal-type-'+refineTerminalTypeName(columnValue)">{{refineTerminalTypeName(columnValue)|removeUnderscore|uppercase}}</span>
  </div>
  <div *ngSwitchCase="DATE">
    {{columnValue| date: !!dateFormat? dateFormat: 'd MMM, y h:mm a' }}
    <!--        <div style="position:relative;top:-.7em">-->
    <!--            <div>  {{columnValue | date: 'd MMM, y'}}</div>-->
    <!--            <div class="m-t-2"> {{columnValue | date: ' h:mm a'}}</div>-->
    <!--        </div>-->
    <!--        {{columnValue| date: 'd MMM, y h:mm a' }}-->
  </div>
  <div *ngSwitchCase="RATE">
    <span class="text-bolder {{getRateColor(columnValue)}}">
      {{columnValue}}
    </span>
  </div>
  <div *ngSwitchCase="RATE_BADGE_GREEN">
    <div *ngIf="!isMobile" class="rating-badge">
      {{columnValue}}
    </div>
    <div *ngIf="isMobile" class="rating-badge-full">
      {{columnValue}}
    </div>
  </div>
  <div *ngSwitchCase="RATE_PROGRESS">
    <div>
      {{columnValue}}
    </div>
    <div *ngIf="!isMobile" class="m-t-11">
      <div class="rating-process">
        <div style="{{getRatingProcessWidth()}};{{getRatingProcessBg()}}" class="rating-process-value">
        </div>
      </div>
    </div>
  </div>
  <div *ngSwitchDefault>
    {{columnValue}}
  </div>
</div>